import React from "react";
import { cn } from "./utils";
import "./empty-state.css";

interface EmptyStateProps {
  title?: string;
  description?: string | React.ReactNode;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}

export function EmptyState({
  title,
  description,
  icon,
  action,
  className,
  fullWidth,
}: EmptyStateProps) {
  return (
    <div
      className={cn("empty-state", fullWidth && "empty-state--full", className)}
    >
      {icon && <div className="empty-state__icon">{icon}</div>}
      {title && <h3 className="empty-state__title">{title}</h3>}
      {description && (
        <div className="empty-state__description">
          {typeof description === "string" ? <p>{description}</p> : description}
        </div>
      )}
      {action && <div className="empty-state__action">{action}</div>}
    </div>
  );
}

